module.exports = __webpack_public_path__ + "img/lsep.8afde04f.jpg";